export default "__VITE_ASSET__B$3yiF9g__"